import React from "react";
import { Box, Typography, GlobalStyles, Button, Card, CardContent, Grid, Chip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ShoppingCart as ShoppingCartIcon, Home as HomeIcon, Receipt as ReceiptIcon, AddShoppingCart } from "@mui/icons-material";
import { useAuth } from "../../AuthProvider";

const recentPurchases = [
  {
    name: "Classroom Bench",
    price: "₹3,500",
    img: "https://images.unsplash.com/photo-1580582932707-520aed937b7b",
    date: "10 Mar 2026",
    description: "Durable wooden bench for classrooms, seats 2-3 students comfortably.",
    category: "Furniture",
    stock: 15,
  },
  {
    name: "Printer",
    price: "₹14,200",
    img: "https://images.unsplash.com/photo-1593642532400-2682810df593",
    date: "09 Mar 2026",
    description: "High-quality laser printer for office and school use, fast printing.",
    category: "Electronics",
    stock: 5,
  },
  {
    name: "Wi-Fi Router",
    price: "₹3,200",
    img: "https://images.unsplash.com/photo-1580894894513-6c7a47b3f6b3",
    date: "08 Mar 2026",
    description: "Reliable Wi-Fi router for high-speed internet connectivity.",
    category: "Electronics",
    stock: 10,
  },
  {
    name: "Football",
    price: "₹1,500",
    img: "https://images.unsplash.com/photo-1546519638-68e109498ffc",
    date: "07 Mar 2026",
    description: "Standard size football for sports activities and games.",
    category: "Sports",
    stock: 20,
  },
];

const Shop = () => {
  const navigate = useNavigate();
  const { oId, board, userId, role, pId } = useAuth();

  return (
    <Box sx={{ mt: 7, mx: 2 }}>
      <Card
        sx={{
          borderRadius: 3,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          backgroundColor: "#fff",
          minHeight: "500px",
          display: "flex",
          flexDirection: "column",
          width: "100%",
          maxWidth: "1200px",
          mx: "auto",
          overflowX: "hidden",
        }}
      >
        <CardContent>
          {/* header */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
              padding: "10px 18px",
              background: "rgba(255,255,255,0.75)",
              backdropFilter: "blur(12px)",
              borderBottom: "1px solid rgba(0,0,0,0.05)",
              boxShadow: "0 8px 30px rgba(0,0,0,0.04)",
              position: "sticky",
              top: 0,
              zIndex: 1000,
            }}
          >
            {/* LOGO */}
            <Box
              sx={{
                fontSize: "20px",
                fontWeight: 800,
                background: "linear-gradient(135deg,#4f5cf1,#7b85ff)",
                color: "#fff",
                px: 2,
                py: 0.6,
                borderRadius: "10px",
                cursor: "pointer",
                boxShadow: "0 8px 20px rgba(79,92,241,.35)",
              }}
            >
              MapEdu
            </Box>

            {/* HOME */}
            <Box
              onClick={() => navigate("/Marketing")}
              sx={{
                fontSize: "14px",
                fontWeight: 700,
                cursor: "pointer",
                px: 2,
                py: 1,
                borderRadius: "10px",
                color: "#1d1d1f",
                background: "transparent",
                transition: "0.25s",
                display: 'flex', alignItems: 'center', gap: 0.5,
                "&:hover": {
                  background: "rgba(79,92,241,0.15)",
                  color: "#4f5cf1",
                },
              }}
            >
              <HomeIcon fontSize="small" /> Home
            </Box>

            {/* SEARCH BAR */}
            <Box
              sx={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                background: "#f1f3ff",
                borderRadius: "12px",
                px: 2,
                py: 0.5,
                maxWidth: "600px",
                transition: "0.3s",
                "&:focus-within": {
                  boxShadow: "0 0 0 2px #4f5cf1",
                  background: "#fff",
                },
              }}
            >
              <Box sx={{ fontSize: "18px", mr: 1, color: "#4f5cf1" }}>🔍</Box>
              <input
                placeholder="Search schools, services, tools..."
                style={{
                  flex: 1,
                  border: "none",
                  outline: "none",
                  background: "transparent",
                  fontSize: "14px",
                }}
              />
            </Box>

            {/* SHOP */}
            <Box
              onClick={() => navigate("/shop")}
              sx={{
                fontSize: "14px",
                fontWeight: 600,
                cursor: "pointer",
                px: 2,
                py: 1,
                borderRadius: "10px",
                color: "#1d1d1f",
                background: "transparent",
                transition: "0.3s",
                display: 'flex', alignItems: 'center', gap: 0.5,
                "&:hover": {
                  background: "#f1f3ff",
                  color: "#4f5cf1",
                },
              }}
            >
              <ShoppingCartIcon fontSize="small" /> Shop
            </Box>

            {/* ORDERS */}
            <Box
              onClick={() => navigate("/order")}
              sx={{
                fontSize: "14px",
                fontWeight: 600,
                cursor: "pointer",
                px: 2,
                py: 1,
                borderRadius: "10px",
                color: "#1d1d1f",
                background: "transparent",
                transition: "0.3s",
                display: 'flex', alignItems: 'center', gap: 0.5,
                "&:hover": {
                  background: "#f1f3ff",
                  color: "#4f5cf1",
                },
              }}
            >
              <ReceiptIcon fontSize="small" /> Orders
            </Box>

            {/* LOGIN */}
            <Button
              variant="contained"
              sx={{
                background: "linear-gradient(135deg,#4f5cf1,#7b85ff)",
                color: "#fff",
                borderRadius: "12px",
                px: 3,
                py: 1,
                fontWeight: 700,
                boxShadow: "0 10px 30px rgba(79,92,241,.4)",
                textTransform: "none",
                "&:hover": {
                  transform: "translateY(-1px)",
                  boxShadow: "0 15px 40px rgba(79,92,241,.5)",
                },
              }}
            >
              Login / Register
            </Button>
          </Box>

          <Box
            sx={{
              width: "100%",
              maxWidth: "1200px",
              mx: "auto",
              overflowX: "hidden",
              minWidth: 0,
            }}
          >
          <Typography
            sx={{
              fontSize: "28px",
              fontWeight: 800,
              mb: 3,
            }}
          >
            Available Products
          </Typography>

          <Grid container spacing={3}>
            {recentPurchases.map((item, index) => (
              <Grid item xs={12} md={6} key={index}>
                <Card
                  sx={{
                    borderRadius: 3,
                    p: 3,
                    transition: ".25s",
                    "&:hover": {
                      boxShadow: "0 10px 25px rgba(0,0,0,.2)",
                    },
                  }}
                >
                  <Box sx={{ display: "flex", gap: 3, alignItems: "flex-start" }}>
                    <Box
                      component="img"
                      src={item.img}
                      alt={item.name}
                      sx={{
                        width: 120,
                        height: 120,
                        objectFit: "cover",
                        borderRadius: 2,
                      }}
                    />

                    <Box sx={{ flex: 1 }}>
                      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 1 }}>
                        <Box>
                          <Typography variant="h6" fontWeight={700}>
                            {item.name}
                          </Typography>
                          <Typography sx={{ color: "#b12704", fontWeight: 800, fontSize: "18px" }}>
                            {item.price}
                          </Typography>
                        </Box>
                        <Chip label={item.category} size="small" color="primary" />
                      </Box>

                      <Typography sx={{ fontSize: 14, color: "gray", mb: 1 }}>
                        {item.description}
                      </Typography>

                      <Typography sx={{ fontSize: 14, color: "gray", mb: 2 }}>
                        Stock: {item.stock} | Last Updated: {item.date}
                      </Typography>

                      <Box sx={{ display: "flex", gap: 2 }}>
                        <Button variant="outlined" size="small">
                          View Details
                        </Button>
                        <Button variant="contained" size="small" startIcon={<AddShoppingCart />}>
                          Add to Cart
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>

          <GlobalStyles
            styles={{
              ".custom-sidebar-scrollbar": {
                scrollbarWidth: "thin",
                scrollbarColor: "grey #e0e0e0",
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar": {
                width: "6px",
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
                background: "#f1f1f1",
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
                backgroundColor: "grey",
                borderRadius: "10px",
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#555",
              },
            }}
          />
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Shop;